<div class="card bg-base-100 shadow-lg hover:shadow-xl transition-all duration-200 cursor-pointer h-full"
  [routerLink]="routerLinkPath"
  (click)="onCardClick()"
  [attr.data-testid]="'course-card-' + courseId">

  <div class="card-body p-4 flex flex-col">
    <!-- Header: Thumbnail + Status -->
    <div class="flex items-start gap-3 mb-3">
      <!-- Thumbnail -->
      <div class="flex-shrink-0">
        @if (thumbnail) {
          <div class="w-12 h-12 rounded-full overflow-hidden bg-base-200">
            <img [src]="thumbnail" [alt]="title" class="w-full h-full object-cover">
          </div>
        } @else {
          <div class="w-12 h-12 rounded-full bg-primary flex items-center justify-center">
            <span class="text-sm font-bold text-primary-content">{{ initials }}</span>
          </div>
        }
      </div>

      <div class="flex-1 min-w-0">
        <div class="flex items-center gap-2">
          @if (mode === 'instructor') {
            <app-icon name="edit_note" size="sm" class="text-primary flex-shrink-0"></app-icon>
          } @else {
            <app-icon name="school" size="sm" class="text-secondary flex-shrink-0"></app-icon>
          }
          <span class="badge badge-sm" [ngClass]="statusBadgeClass">{{ statusLabel }}</span>
        </div>
      </div>
    </div>

    <!-- Title -->
    <h3 class="card-title text-lg mb-1 user-text-clamp-2" [title]="title">{{ title }}</h3>

    <!-- Description -->
    @if (description) {
      <p class="text-sm text-base-content opacity-70 mb-2 user-text-clamp-2" [title]="description">{{ description }}</p>
    }

    <!-- Content Stats -->
    <div class="text-xs text-base-content opacity-60 mb-2">
      @if (mode === 'instructor') {
        <span>{{ modulesCount }} module{{ modulesCount === 1 ? '' : 's' }}</span>
      } @else {
        <div class="flex flex-wrap gap-2">
          @if (unitsCount) {
            <span>{{ unitsCount }} unit{{ unitsCount === 1 ? '' : 's' }}</span>
          }
          @if (modulesCount) {
            <span>{{ modulesCount }} module{{ modulesCount === 1 ? '' : 's' }}</span>
          }
          @if (quizzesCount) {
            <span>{{ quizzesCount }} quiz{{ quizzesCount === 1 ? '' : 'zes' }}</span>
          }
        </div>
      }
    </div>

    <!-- Learner: Progress Bar (KAN-427: mt-auto bottom-anchors the whole
         progress -> button -> footer group so bars align across a grid row) -->
    @if (showProgressBar) {
      <div class="w-full mb-2 mt-auto">
        <div class="flex justify-between text-xs mb-1">
          <span>Progress</span>
          <span class="font-medium">{{ progressPercent }}%</span>
        </div>
        <progress class="progress progress-primary w-full h-2"
          [value]="progressPercent"
          max="100"></progress>
      </div>
    }

    <!-- Learner: Enrollment Deadline -->
    @if (mode === 'learner' && enrollmentDeadline && learnerStatus === 'enrolled') {
      <div class="text-xs text-warning mb-2">
        <app-icon name="schedule" size="xs" class="mr-1"></app-icon>
        Deadline: {{ enrollmentDeadline | date:'shortDate' }}
      </div>
    }

    <!-- Learner: Renew (access expired) takes precedence over Continue -->
    @if (mode === 'learner' && accessExpired) {
      <button
        (click)="onRenew($event)"
        class="btn btn-warning btn-sm w-full mb-2"
        data-testid="course-card-renew-btn">
        <app-icon name="shopping_cart" size="xs"></app-icon>
        Renew access
      </button>
    } @else if (mode === 'learner' && canContinue) {
      <button
        (click)="onContinue($event)"
        class="btn btn-primary btn-sm w-full mb-2">
        <app-icon name="play_arrow" size="xs"></app-icon>
        Continue
      </button>
    }

    <!-- Footer (KAN-427: mt-auto only when the progress block is absent; when the
         progress block is shown IT owns the single spacer so the group stays grouped) -->
    <div class="flex justify-between items-center gap-2 pt-3 border-t border-base-300"
      [class.mt-auto]="!showProgressBar">
      <span class="text-xs text-base-content opacity-50 truncate min-w-0" [title]="organizationName">
        {{ organizationName }}
      </span>
      <div class="flex items-center gap-2">
        @if (mode === 'learner' && hasCertificate) {
          <span class="badge badge-success badge-sm gap-1">
            <app-icon name="military_tech" size="xs"></app-icon>
            Cert
          </span>
        }
        @if (mode === 'instructor' && timeAgo) {
          <span class="text-xs text-base-content opacity-50">{{ timeAgo }}</span>
        }
      </div>
    </div>
  </div>
</div>
